export const environment = {
  production: true,
  API_BASE_URL: 'https://api-1.test.thescope.com/api',
  CONTENT_SUITE_URL: 'https://app.test.thescope.com',
  DISCOVERY_BASE_URL: 'https://discovery.test.thescope.com/api',
  // No access tokens on TEST (Stojan, 19 Oct 2026): the Discovery MCP server reads PROD only. MCP access says so and
  // never calls the token endpoints.
  ACCESS_TOKENS_ENABLED: false,
};
